import { configureStore } from "@reduxjs/toolkit";
import { useDispatch, useSelector } from "react-redux";
import type { TypedUseSelectorHook } from "react-redux";
import loaderSlice from "./slices/loadingSlice";
import bookingSlice from "./slices/bookingSlice";
import languageReducer from "./slices/languageSlice";
import noticeSlice from "./slices/notices";

export const store = configureStore({
  reducer: {
    loader: loaderSlice.reducer,
    booking: bookingSlice.reducer,
    language: languageReducer,
    notices: noticeSlice.reducer,
  },
});

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
